import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
  margin: 0;
  padding: clamp(2.75rem, 6vw, 4.25rem) clamp(1.25rem, 4vw, 2rem);
  border-top: 1px solid rgba(16, 29, 64, 0.07);
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.offWhite} 0%,
    rgba(241, 239, 234, 0.92) 48%,
    ${({ theme }) => theme.colors.offWhite} 100%
  );
`;

const ContentContainer = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: clamp(2rem, 6vw, 4rem);
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const LeftColumn = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
`;

const Title = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.main};
  font-size: clamp(1.85rem, 4vw, 2.65rem);
  font-weight: 700;
  line-height: 1.12;
  color: ${({ theme }) => theme.colors.primary};
  text-align: left;

  &::after {
    content: '';
    display: block;
    width: 3rem;
    height: 2px;
    margin: 1.1rem 0 0;
    border-radius: 2px;
    background: linear-gradient(
      90deg,
      transparent,
      ${({ theme }) => theme.colors.accent},
      transparent
    );
    opacity: 0.85;
  }

  @media (max-width: 768px) {
    &::after {
      margin-top: 0.85rem;
    }
  }
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
`;

const Description = styled.p`
  margin: 0 0 1.65rem;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: clamp(0.95rem, 1.85vw, 1.08rem);
  line-height: 1.65;
  color: rgba(16, 29, 64, 0.62);

  @media (max-width: 768px) {
    margin-bottom: 1.35rem;
  }
`;

const Button = styled.button`
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.accent};
  color: white;
  border: none;
  padding: 0.78rem 1.85rem;
  border-radius: 999px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(157, 109, 73, 0.35);
  transition:
    opacity 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    opacity: 0.96;
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(157, 109, 73, 0.42);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 3px;
  }

  &:active {
    transform: translateY(0);
  }
`;

const ColumnX2 = ({ title, description, buttonText, buttonAction }) => {
  return (
    <SectionWrapper>
      <ContentContainer>
        <LeftColumn>
          <Title>{title}</Title>
        </LeftColumn>
        <RightColumn>
          <Description>{description}</Description>
          {buttonText && (
            <Button type="button" onClick={buttonAction}>
              {buttonText}
            </Button>
          )}
        </RightColumn>
      </ContentContainer>
    </SectionWrapper>
  );
};

export default ColumnX2;
